import { render } from "./VerPracticante.vue?vue&type=template&id=63e1939f&scoped=true"
import script from "./VerPracticante.vue?vue&type=script&lang=js"
export * from "./VerPracticante.vue?vue&type=script&lang=js"

import "./VerPracticante.vue?vue&type=style&index=0&id=63e1939f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e1939f"]])

export default __exports__